{
	"label": "Spårbarhet för koldioxidbesparingar",
	"title": "Spårbarhet för koldioxidbesparingar",
	"paragraph": "Koldioxidbesparingar kan lagras säkert på en blockkedja, vilket säkerställer transparens och spårbarhet. Genom att använda blockkedjeteknik kan varje koldioxidbesparande transaktion registreras och verifieras på ett decentraliserat och oföränderligt sätt. Detta möjliggör ett tillförlitligt och granskningsbart system där utsläppsminskningar kan spåras och redovisas korrekt. Det innebär att en transaktion för samma koldioxidkredit inte kan göras flera gånger.",
	"close": "Stäng"
}
